module.exports = __webpack_public_path__ + "img/feature_03.b0900547.jpg";